export enum Action {
  KILL = 0,
  HELP = 1,
  BUILD = 2
}

export enum CharacterEvent {
  PATH_COMPLETE = 'path-complete',
  PATH_RESET = 'path-reset'
}
